import { isMobile } from 'react-device-detect';
export function isMobileDevice() {
    return isMobile;
}
